
export const drawingsArticleData = {
  badge: 'drawingsArticle.badge',
  title: 'drawingsArticle.title',
  p1: 'drawingsArticle.p1',
  p2: 'drawingsArticle.p2',
  p3: 'drawingsArticle.p3',
  p4: 'drawingsArticle.p4',
  p5: 'drawingsArticle.p5',
  quote: 'drawingsArticle.quote',
};

export default drawingsArticleData;